/**
 * Assets 左侧导航 — IA 对齐 spikex-ai-web/lib/nav.ts ASSETS_NAV
 */

import {
  IconNavLayoutDashboard,
  IconNavLineChart,
  IconNavHistory,
} from "../globalHeader/navIcons";

function tr(t, key, fallback) {
  if (!t || !key) return fallback;
  const value = t(key);
  return value && value !== key ? value : fallback;
}

/** 主栏目页（PC 顶栏标题） */
export const ASSETS_MAIN_SECTION_KEYS = {
  convert: {
    labelKey: "convert.buySell",
    labelFallback: "Buy/Sell",
    subtitleKey: "convert.pageDesc",
    subtitleFallback: "Swap between assets instantly at zero trading fees.",
  },
  buy: {
    labelKey: "credit.BuyCrypto",
    labelFallback: "Buy Crypto",
    subtitleKey: "credit.buySubtitle",
    subtitleFallback: "Buy crypto with card, Pix or bank transfer.",
  },
  convertHistory: {
    labelKey: "convert.transactionHistory",
    labelFallback: "Transaction History",
    subtitleKey: "convert.historyDesc",
    subtitleFallback: "View your convert orders and settlement status.",
  },
  trading: {
    labelKey: "header.trading",
    labelFallback: "Trading",
    subtitleKey: "assets.tradingSubtitle",
    subtitleFallback: "Open positions and orders across Spot, Futures and AI.",
  },
};

export function buildAssetsNav({ t, getUrl }) {
  const items = [
    {
      id: "overview",
      labelKey: "header.overview",
      labelFallback: "Overview",
      href: getUrl("/wallet/account/overview"),
      icon: IconNavLayoutDashboard,
      matchKeys: ["overview", "convert", "buy"],
    },
    {
      id: "trading",
      labelKey: "header.trading",
      labelFallback: "Trading",
      href: getUrl("/wallet/account/trading"),
      icon: IconNavLineChart,
      matchKeys: ["trading"],
    },
    {
      id: "history",
      labelKey: "nav.history",
      labelFallback: "History",
      href: getUrl("/bills/spot/deposit"),
      icon: IconNavHistory,
      matchKeys: ["history"],
    },
  ];

  return items.map((item) => ({
    ...item,
    label: tr(t, item.labelKey, item.labelFallback),
  }));
}

export function resolveActiveAssetsNavId(navItems, tabKey) {
  for (const item of navItems) {
    if (item.matchKeys?.includes(tabKey)) return item.id;
  }
  return null;
}
